import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Button
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

const ManualModeConflictDialog: React.FC = () => {
  const contineuRef = useRef(null);
  const { t } = useTranslation();

  const reloadTab = () => window.location.reload();

  return (
    <AlertDialog
      isOpen={true}
      leastDestructiveRef={contineuRef}
      onClose={() => {}}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t('permission.manualMode.title')}
          </AlertDialogHeader>

          <AlertDialogBody>
            {t('permission.manualMode.description')}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button colorScheme="red" onClick={reloadTab}>
              {t('permission.manualMode.reload')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ManualModeConflictDialog;
